import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { CustomDotCmsContentlet } from '../../models/contentlet/custom-dotcms-contentlet.model';

import { loadDotCmsContentletSuccess, loadDotCmsContentletsSuccess } from './dotcms-contentlets.action';

export type DotCmsContentletsState = EntityState<CustomDotCmsContentlet>;

export const dotCmsContentletsEntityAdapter = createEntityAdapter<CustomDotCmsContentlet>({
  selectId: contentlet => contentlet.identifier,
});

const initialState = dotCmsContentletsEntityAdapter.getInitialState({});

export const dotCmsContentletsReducer = createReducer(
  initialState,
  on(loadDotCmsContentletsSuccess, (state, action) => ({
    ...dotCmsContentletsEntityAdapter.setMany(action.payload.contentlets, state),
  })),
  on(loadDotCmsContentletSuccess, (state, action) => ({
    ...dotCmsContentletsEntityAdapter.setOne(action.payload.contentlet, state),
  }))
);
